import React from 'react'

import { ResizeContext } from 'contexts/Resize'

import WForeverDesktop from './components/WForeverDesktop'
import WForeverMobile from './components/WForeverMobile'

const WForever = props => {
  const { mobile, tablet, breakpoint } = React.useContext(ResizeContext)

  if (mobile || tablet || breakpoint === '') {
    return <WForeverMobile {...props} />
  }

  return <WForeverDesktop {...props} />
}

export default WForever
